module.exports = __webpack_public_path__ + "static/new-brunswick-f1068e4738c0922def3d41fe7b5fcec0.png";